import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import * as rstm from 'react-simple-tree-menu';

import ValidationAlert from '../../../app/components/ValidationAlert';
import { GetDictionaryTypeDto } from '../../../common/spdCore/autogenerated/spdApiClient/models';
import {
  newDictionary,
  convert,
} from '../../../common/spdCore/contexts/DictionaryContext';
import * as DictionaryContext from '../../../common/spdCore/contexts/DictionaryContext';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import Button from '../../../common/components/Button';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

interface DictionaryDeleteModalProps {
  item: rstm.TreeMenuItem;
  onAction: (id?: string) => void;
  show?: boolean;
  onClose?: () => void;
}

export const DictionaryDeleteModal: React.FC<DictionaryDeleteModalProps> = ({
  item,
  onAction,
  show,
  onClose,
}) => {
  const spd = useSpdCore();
  const notifications = useNotifications();

  const [dictionary, setDictionary] = useState(newDictionary());
  const [dictionaryType, setDictionaryType] = useState<GetDictionaryTypeDto>();

  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [validationErrors, setValidationErrors] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    spd.dictionaries
      .getById(item.id)
      .then(dict => {
        setDictionary(convert(dict));
        setDictionaryType(dict.dictionaryType);
      })
      .catch(errorResponse => {
        console.log(errorResponse);
      });
  }, [item.dictionaryTypeId, item.id, spd, notifications]);

  const handleSave = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.stopPropagation();
    setIsLoading(true);
    DictionaryContext.validate(dictionary)
      .then(async status => {
        setValidationErrors(status.errors);
        if (status.valid) {
          setShowValidationErrors(false);
          try {
            await spd.dictionaries.changeToInactive(item.id);
            onAction();
          } catch (response) {
            setValidationErrors(
              await responseErrors(response as ResponseError),
            );
            setShowValidationErrors(true);
          }
        } else {
          setShowValidationErrors(true);
        }
      })
      .catch(errorResponse => {
        console.error(errorResponse);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Modal
      onHide={onClose}
      show={show}
      keyboard={true}
      centered={true}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Usuwanie ze słownika <b>{dictionaryType?.name}</b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Czy na pewno usunąć wartość: <b>{dictionary.value}</b>?
      </Modal.Body>
      <ValidationAlert
        show={showValidationErrors}
        errors={validationErrors}
        className="m-3"
      />
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={onClose}
          disabled={isLoading}
        >
          Zamknij
        </Button>
        <Button variant="danger" onClick={handleSave} isLoading={isLoading}>
          Usuń
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
